import React, { Fragment } from 'react'
import { string } from 'prop-types'
import { useIntl } from 'react-intl'
import { ARTICLE_ARCHIVE } from '../../../utils/constants'
import { tagFiltersMessages } from '../../../hoc/messages'
import Icon from '../icon/Icon'

const AD_HOME = { label: 'ArchDaily', url: 'https://www.archdaily.com' }

const BREADCRUMB_PATHS = {
  [ARTICLE_ARCHIVE]: [
    { label: 'Archive', url: 'https://www.archdaily.com/search/article-archive' }
  ]
}

const Breadcrumbs = ({ searchType, activeItem }) => {
  const intl = useIntl()
  const paths = BREADCRUMB_PATHS[searchType]
  let label = activeItem

  if (!activeItem) return null

  if (searchType === ARTICLE_ARCHIVE) {
    label = intl.formatMessage({ ...tagFiltersMessages[activeItem] })
  }
  const lastPath = { label, url: `${paths[paths.length - 1].url}/topic/${activeItem}` }

  return (
    <nav className='search-header__breadcrumbs'>
      {[AD_HOME, ...paths, lastPath].map((item, index) => {
        return <Fragment key={`breadcrumb-item-${index}`}>
          {index > 0 && <Icon svg='rightChevron' withoutEvents />}
          <a
            href={item.url}
            className='search-header__breadcrumbs-item'
          >
            {item.label}
          </a>
        </Fragment>
      })}
    </nav>
  )
}

Breadcrumbs.propTypes = {
  searchType: string,
  activeItem: string
}

export default Breadcrumbs
